import { render, staticRenderFns } from "./shopMangnier.vue?vue&type=template&id=b44e8a5c&scoped=true"
import script from "./shopMangnier.vue?vue&type=script&lang=js"
export * from "./shopMangnier.vue?vue&type=script&lang=js"
import style0 from "./shopMangnier.vue?vue&type=style&index=0&id=b44e8a5c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44e8a5c",
  null
  
)

export default component.exports